// DS: I3.1
import React from 'react';
import IconWrap from '../../IconWrap';
const Close = (props)=>/*#__PURE__*/ React.createElement(IconWrap, props, /*#__PURE__*/ React.createElement("svg", {
        width: "0",
        height: "0",
        viewBox: "0 0 16 16",
        xmlns: "http://www.w3.org/2000/svg"
    }, /*#__PURE__*/ React.createElement("path", {
        fillRule: "evenodd",
        clipRule: "evenodd",
        d: "M12.95 3.05a1 1 0 010 1.414L9.415 8l3.606 3.608a1 1 0 01.083 1.32l-.083.094a1 1 0 01-1.32.083l-.094-.083L8 9.414 4.465 12.95a1 1 0 01-1.414-1.414l3.535-3.537-3.464-3.463a1 1 0 01-.083-1.32l.083-.095a1 1 0 011.32-.083l.094.083L8 6.585l3.536-3.535a1 1 0 011.414 0z",
        fill: "currentColor"
    })));
Close.displayName = 'Close';
export default Close;

//# sourceMappingURL=Close.js.map